var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { ArrayNotEmpty, IsArray, IsNumber, IsString, ValidateNested, } from 'class-validator';
import { CreateD2CRefundPolicyDateRangeDto } from './create-d2c-refund-policy-date-range.dto';
import { CreateD2CRefundPolicyRuleDto } from './create-d2c-refund-policy-rule.dto';
export class CreateD2CRefundPolicyDto {
}
__decorate([
    IsString({ message: '정책 이름을 입력해주세요.' }),
    __metadata("design:type", String)
], CreateD2CRefundPolicyDto.prototype, "name", void 0);
__decorate([
    IsNumber({}, { message: '우선순위를 입력해주세요.' }),
    __metadata("design:type", Number)
], CreateD2CRefundPolicyDto.prototype, "priority", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => CreateD2CRefundPolicyDateRangeDto),
    __metadata("design:type", Array)
], CreateD2CRefundPolicyDto.prototype, "dateRanges", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => CreateD2CRefundPolicyRuleDto),
    ArrayNotEmpty({
        message: '최소 하나 이상의 규정을 입력해주세요.',
    }),
    __metadata("design:type", Array)
], CreateD2CRefundPolicyDto.prototype, "rules", void 0);
